<mobile-page-content [fullPageWidth]="true" class="page-content">
  <app-mobile-header header [hasSideMenu]="true"></app-mobile-header>

  <app-mobile-side-menu right-menu></app-mobile-side-menu>

  <mobile-diary-list-content>
  </mobile-diary-list-content>

</mobile-page-content>

